import { ItineraryService } from './../itinerary.service';
import { ActivatedRoute } from "@angular/router";
import { Itinerary } from "./../itineray.model";
import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { v4 as uuid } from "uuid";

@Component({
  selector: "app-itinerary-reservations-flights",
  templateUrl: "./itinerary-reservations-flights.component.html",
  styleUrls: ["./itinerary-reservations-flights.component.css"]
})
export class ItineraryReservationsFlightsComponent implements OnInit {
  constructor(private route: ActivatedRoute, private snackBar: MatSnackBar, public itineraryService: ItineraryService) { }

  itinerary: Itinerary;

  expanded: boolean[];

  ngOnInit() {
    this.itinerary = this.route.parent.parent.snapshot.data.itinerary;
    this.syncExpanded();
  }

  private syncExpanded(expandLast: boolean = false) {
    this.expanded = [];
    this.itinerary.reservations.flights.forEach((item) => this.expanded.push(false));
    if (expandLast) {
      this.expanded[this.expanded.length - 1] = true;
    }
  }

  removeFlight($event, flight) {
    $event.stopPropagation();
    if (confirm("Vuoi veramente eliminare questo volo?")) {
      const idx = this.itinerary.reservations.flights.indexOf(flight);
      this.itinerary.reservations.flights.splice(idx, 1);
      this.snackBar
        .open("Volo eliminato.", "Annulla", {
          duration: 4000
        })
        .onAction()
        .subscribe(() => {
          this.itinerary.reservations.flights.splice(idx, 0, flight);
          this.snackBar.open(
            "Il volo che avevi eliminato è stato inserito nuovamente nella lista.",
            null,
            {
              duration: 4000
            }
          );
        });
      this.syncExpanded();
    }
  }

  addFlight() {
    this.itinerary.reservations.flights.push({
      id: uuid(),
      notes: null,
      link: { longUrl: null, shortUrl: null },
      partner: null,
      price: null,
      routes: [
        {
          id: uuid(),
          title: "",
          company: "",
          code: "",
          from: "",
          fromDetail: "",
          fromCode: "",
          fromPlace: null,
          to: "",
          toDetail: "",
          toCode: "",
          toPlace: null,
          start: null,
          end: null,
          stops: null,
          duration: {
            hours: null,
            minutes: null
          }
        },
        {
          id: uuid(),
          title: "",
          company: "",
          code: "",
          from: "",
          fromDetail: "",
          fromCode: "",
          fromPlace: null,
          to: "",
          toDetail: "",
          toCode: "",
          toPlace: null,
          start: null,
          end: null,
          stops: null,
          duration: {
            hours: null,
            minutes: null
          }
        }
      ]
    });
    this.syncExpanded(true);
  }
}
